import { toast } from "react-toastify";
import Copy from "../images/copy.svg"
import CopyDark from "../images/copy-dark.svg"
import Speaker from "../images/volume.svg"
import SpeakerDark from "../images/volume-low-dark.svg"
import ThumbsDown from "../images/thumbs-down.svg"
import ThumbsDownDark from "../images/thumbs-down-dark.svg"
import ThumbsUp from "../images/thumbs-up.svg"
import ThumbsUpDark from "../images/thumbs-up-dark.svg"


export const handleSpeak = (text: string, id: string): void => {
  const speakElement = document.getElementById(id) as HTMLImageElement | null;

  if (!speakElement) return;

  let isAlreadySpeaking = false;
  speechSynthesis.cancel();

  document.querySelectorAll<HTMLImageElement>(".speak").forEach((element) => {
    if (element.id === id && element.src.includes(SpeakerDark)) {
      isAlreadySpeaking = true;
    }
    element.src = Speaker;
  });

  if (isAlreadySpeaking) return;

  speakElement.src = SpeakerDark;
  const cleanedText = text
    .replace(/\*/g, "")
    .replace(/\[/g, "")
    .replace(/\]/g, "")
    .replace(/\(https?:\/\/[^\s)]+\)/g, "")
    .replace(/\s+/g, " ")
    .trim();

  const splitTexts = cleanedText.split(/(?=\b\d{1,10}\.\s)/).map(chunk => chunk.trim()).filter(Boolean);
  const sentences = splitTexts
    .flatMap(splitText =>
      splitText
        .split(/[.?!;:\n]+/)
        .map(sentence => sentence.trim())
        .filter(Boolean)
    );
  const chunks: string[] = [];
  sentences.forEach((sentence) => {
    const chunked = sentence.match(/.{1,100}(\s|$)/g) || [];
    chunks.push(...chunked.map(chunk => chunk.trim()));
  });

  let index = 0;

  const speakChunk = () => {
    if (index >= chunks.length) {
      speakElement.src = Speaker;
      return;
    }

    const speech = new SpeechSynthesisUtterance(chunks[index]);
    speech.lang = "en-US";
    speech.pitch = 1;
    speech.onend = () => {
      index++;
      speakChunk();
    };

    speechSynthesis.speak(speech);
  };

  speakChunk();
};


export const handleCopy = async (text: string, id: string): Promise<void> => {
  const copyElement = document.getElementById(id) as HTMLImageElement | null;

  if (copyElement) { copyElement.src = CopyDark; }

  try {
    await navigator.clipboard.writeText(text);
    toast.success("Copy Content Successfully!", { position: "top-right", autoClose: 3000 });
  }
  catch (error) {
    toast.error("Failed to copy content!", { position: "top-right", autoClose: 3000 });
  }
  setTimeout(() => { if (copyElement) { copyElement.src = Copy; } }, 3000);
};


export const handleLike = (datetime: string, action: "like" | "unlike") => {
  const likeElement = document.getElementById(`${datetime}like`) as HTMLImageElement | null;
  const unlikeElement = document.getElementById(`${datetime}unlike`) as HTMLImageElement | null;

  if (likeElement && unlikeElement) {
    if (action === "like") {
      likeElement.src = likeElement.src.includes(ThumbsUpDark) ? ThumbsUp : ThumbsUpDark;
      unlikeElement.src = ThumbsDown;
    }
    else {
      unlikeElement.src = unlikeElement.src.includes(ThumbsDownDark) ? ThumbsDown : ThumbsDownDark;
      likeElement.src = ThumbsUp;
    }
  }
};



export const validateMobile = (mobile: unknown): boolean => {
  if (typeof mobile !== "string") {
    toast.error("Invalid input type. Mobile number must be a string.", { position: "top-right", autoClose: 3000 });
    return false;
  }

  const trimmedMobile = mobile.trim();
  if (!trimmedMobile) {
    toast.error("Mobile number is required.", { position: "top-right", autoClose: 3000 });
    return false;
  }

  if (!/^\d+$/.test(trimmedMobile)) {
    toast.error("Mobile number must contain only digits.", { position: "top-right", autoClose: 3000 });
    return false;
  }

  // if (trimmedMobile.length < 10) {
  //   toast.error("Mobile number must be at least 10 digits long.");
  //   return false;
  // }

  if (trimmedMobile.length > 15) {
    toast.error("Mobile number cannot exceed 15 digits.", { position: "top-right", autoClose: 3000 });
    return false;
  }
  return true;
};
